import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/short bread.png";
import BiscuitImg from "../../../assets/products/crispy bites/Short-Bread-Cookies.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 114,
  },
  {
    grams: 150,
  },
  {
    grams: 500,
  },
];

export default function ShortbreadProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Shortbread Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Shortbread Biscuits — melt-in-the-mouth buttery texture with crispness. View pack sizes, carton details, and global specs."
        />
        <meta
          name="keywords"
          content="Crispy Shortbread Biscuit, BearBitz Shortbread Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/shortbread"
        />
        <meta
          property="og:title"
          content="Crispy Shortbread Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Buttery, crisp shortbread biscuits by BearBitz, perfect for premium snacking and export markets."
        />
      </Helmet>

      <ProductTemplate
        productTitle="SHORT BREAD"
        productImage={BisImg}
        description="Timeless Taste, Elegant Indulgence. Crumbly, buttery classics baked with tradition—perfect for premium moments. Exported in style to meet global demand for quality."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#733806"
        sectionBgColor="#FDF3DC"
        productBgcolor="#FEFAF1"
        tableheadBgcolor="#733806"
        tableBgcolor="#FEFAF1"
        footerBgcolor="#733806"
      />
    </>
  );
}
